var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVanuatu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 513,
    viewBox: "0 0 512 513",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_7326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512 256.002C512 244.685 511.257 233.541 509.833 222.611H222.606C170.305 170.313 74.976 74.9899 74.98 74.9819C-24.994 174.956 -24.994 337.046 74.98 437.022L222.609 289.394H509.833C511.256 278.463 512 267.319 512 256.002V256.002Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.927 261.824C511.916 262.318 511.905 262.814 511.891 263.308C511.903 262.812 511.915 262.318 511.927 261.824Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.681 268.82C511.658 269.309 511.624 269.796 511.598 270.284C511.624 269.797 511.656 269.309 511.681 268.82Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.336 274.4C511.285 275.119 511.235 275.838 511.177 276.555C511.235 275.838 511.284 275.119 511.336 274.4Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.481 228.1C510.575 228.956 510.669 229.811 510.754 230.669C510.669 229.81 510.574 228.956 510.481 228.1Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.597 241.719C511.624 242.207 511.657 242.694 511.68 243.183C511.656 242.694 511.624 242.206 511.597 241.719Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.89 248.697C511.904 249.191 511.914 249.687 511.926 250.181C511.915 249.685 511.903 249.191 511.89 248.697Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.177 235.448C511.235 236.165 511.285 236.884 511.336 237.603C511.284 236.884 511.235 236.165 511.177 235.448Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.833 222.61C509.948 223.487 510.05 224.369 510.155 225.248C494.961 98.3659 386.975 0.00195312 256 0.00195312C185.306 0.00195312 121.305 28.657 74.978 74.986L222.602 222.611H509.833V222.61Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.833 289.393H222.602L74.978 437.018C121.305 483.346 185.306 512.002 256 512.002C386.975 512.002 494.962 413.638 510.155 286.755C510.05 287.634 509.946 288.516 509.833 289.393V289.393Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.753 281.334C510.668 282.192 510.574 283.047 510.48 283.903C510.574 283.047 510.669 282.193 510.753 281.334Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.336 237.603C511.433 238.972 511.521 240.344 511.596 241.719C511.52 240.344 511.433 238.972 511.336 237.603V237.603Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.155 225.248C510.27 226.197 510.379 227.148 510.481 228.1C510.377 227.148 510.268 226.198 510.155 225.248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.753 230.669C510.909 232.258 511.05 233.851 511.177 235.45C511.051 233.851 510.91 232.257 510.753 230.669Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 256.002C512 257.949 511.97 259.888 511.927 261.823C511.97 259.887 512 257.948 512 256.002Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.597 270.284C511.521 271.659 511.433 273.031 511.337 274.4C511.433 273.031 511.52 271.659 511.597 270.284Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.177 276.555C511.05 278.152 510.909 279.746 510.753 281.334C510.91 279.746 511.051 278.152 511.177 276.555Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.481 283.903C510.379 284.855 510.27 285.805 510.155 286.755C510.268 285.806 510.377 284.855 510.481 283.903Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.927 250.18C511.97 252.116 512 254.056 512 256.001C512 254.056 511.97 252.116 511.927 250.18Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.681 243.183C511.771 245.015 511.839 246.854 511.891 248.696C511.839 246.853 511.772 245.015 511.681 243.183Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.89 263.308C511.838 265.15 511.77 266.989 511.68 268.821C511.772 266.988 511.839 265.15 511.89 263.308Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.756 244.779H213.201L59.8441 91.4448C54.8871 96.6728 49.5141 103.973 46.1911 109.172L192.85 255.908L46.0681 402.693C48.9741 407.863 55.3051 415.515 59.7501 420.494L213.204 267.04H511.792C511.951 263.348 512.001 259.64 512.001 255.91C512 250.912 511.862 247.227 511.756 244.779Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1871 310.574V289.131C83.5851 289.131 100.992 271.722 100.992 250.326C100.992 235.187 88.6751 222.871 73.5371 222.871C63.2241 222.871 54.8331 231.261 54.8331 241.576C54.8331 248.171 60.1981 253.537 66.7941 253.537C70.5221 253.537 73.5551 250.502 73.5551 246.774H94.9971C94.9971 262.327 82.3451 274.979 66.7951 274.979C48.3761 274.98 33.3931 259.994 33.3931 241.578C33.3931 219.441 51.4031 201.432 73.5381 201.432C100.5 201.432 122.436 223.368 122.436 250.329C122.435 283.546 95.4081 310.574 62.1871 310.574V310.574Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_7326"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512.001,
    height: 512.001,
    fill: "white",
    transform: "translate(0 0.000976562)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVanuatu);
export default __webpack_public_path__ + "static/media/vanuatu.768c7b101c890ac9e488455f5d8bd48e.svg";
export { ForwardRef as ReactComponent };